/**
 * Data Corruption PostFX Pipeline
 * Custom Phaser 3 post-processing pipeline for horror effects
 */

import Phaser from 'phaser';
import { DataCorruptionFragShader } from '../shaders/DataCorruption.frag.js';

export class DataCorruptionPipeline extends Phaser.Renderer.WebGL.Pipelines.PostFXPipeline {
    constructor(game) {
        super({
            game,
            name: 'DataCorruption',
            fragShader: DataCorruptionFragShader
        });

        // Effect parameters
        this._intensity = 0;
        this._time = 0;
    }

    onPreRender() {
        this._time += 0.016; // Approximate 60fps delta

        this.set1f('uTime', this._time);
        this.set1f('uIntensity', this._intensity);
        this.set2f('uResolution', this.renderer.width, this.renderer.height);
    }

    // Set corruption intensity (0-1)
    setIntensity(value) {
        this._intensity = Phaser.Math.Clamp(value, 0, 1);
    }

    // Get current intensity
    getIntensity() {
        return this._intensity;
    }

    // Smooth transition to target intensity
    transitionTo(targetIntensity, duration, scene) {
        scene.tweens.addCounter({
            from: this._intensity,
            to: targetIntensity,
            duration: duration,
            onUpdate: (tween) => {
                this._intensity = tween.getValue();
            }
        });
    }

    // Pulse effect (quick spike and return)
    pulse(peakIntensity, duration, scene) {
        const originalIntensity = this._intensity;

        scene.tweens.addCounter({
            from: this._intensity,
            to: peakIntensity,
            duration: duration / 2,
            yoyo: true,
            onUpdate: (tween) => {
                this._intensity = tween.getValue();
            },
            onComplete: () => {
                this._intensity = originalIntensity;
            }
        });
    }
}

// Register the pipeline with Phaser
export function registerDataCorruptionPipeline(game) {
    if (game.renderer.type === Phaser.WEBGL) {
        const renderer = game.renderer;

        if (!renderer.pipelines.has('DataCorruption')) {
            renderer.pipelines.addPostPipeline('DataCorruption', DataCorruptionPipeline);
        }

        return true;
    }

    console.warn('DataCorruption pipeline requires WebGL renderer');
    return false;
}
